import { render, staticRenderFns } from "./EditMaterialTarget.vue?vue&type=template&id=3b18a1f2&scoped=true&"
import script from "./EditMaterialTarget.vue?vue&type=script&lang=js&"
export * from "./EditMaterialTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b18a1f2",
  null
  
)

export default component.exports